import {baseApi} from "./BaseApi";
import * as constants from "../assets/constants";

class DadataApi extends baseApi {

    suggestCompany = async (data, additionals) => {

        return await this.post('?app=ddataApi&act=suggestCompany' + (additionals ? '&' + additionals : ''), data)

    }

}

export default new DadataApi(constants.DEBUG ? constants.base_url_stage : constants.base_url_prod);